import {
  CommentsTotal,
  IComments,
  TComment,
  TCommentsListQuery,
  TDataForUpdateCreateComment,
} from '../interfaces/comments';

import { ProxyClient } from './client/ProxyClient';

export const getComments = async (query: TCommentsListQuery) => {
  const { data } = await ProxyClient.get<IComments>('/comments', { params: query });
  return data;
};

export const getCommentsTotal = async (articleId: number) => {
  const { headers } = await ProxyClient.head(`/comments/total/${articleId}`, {
    method: 'HEAD',
  });
  return +headers.total;
};

export const getCommentsTotalForList = async (articleIds: number[]) => {
  const { data } = await ProxyClient.get<CommentsTotal[]>('/comments/totals', {
    params: {
      postIds: articleIds,
    },
  });

  return data;
};

export const postComment = async (commentData: TDataForUpdateCreateComment) => {
  const { data } = await ProxyClient.post<TComment>('/comment/post', commentData, {
    method: 'POST',
  });
  return data;
};

export const updateComment = async (commentId: number, commentData: TDataForUpdateCreateComment) => {
  const { data } = await ProxyClient.put<TComment>(`/comment/update/${commentId}`, commentData, {
    method: 'PUT',
  });
  return data;
};

export const deleteComment = async (commentId: number) => {
  await ProxyClient.delete<IComments>(`/comment/delete/${commentId}`, {
    method: 'DELETE',
  });
};
